<template>
  <section class="app-navbar animated" :class="{ slideInDown: show, slideOutDown: !show }">
    <nav class="navbar is-transparent">
      <div class="navbar-brand">
        <a class="nav-item" @click="toggleSidebar()" v-show="($route.path==='/' || $route.path==='/forgotPassword'|| $route.path==='/requestDemo'|| $route.path.indexOf('/resetPassword') !== -1 || $route.path==='/login' || $route.path==='/onBoard' || $route.path==='/terms' || $route.path.indexOf('/onBoardMember') !== -1)? false : true">
          <i class="fa fa-bars" aria-hidden="true" v-show="!sidebarOpen"></i>
          <i class="fa fa-times" aria-hidden="true" v-show="sidebarOpen" style="font-size: 17.5px;"></i>
        </a>

        <a href="http://www.changevu.com" v-show="($route.path==='/' || $route.path==='/forgotPassword'|| $route.path==='/onBoard' || $route.path.indexOf('/onBoardMember') !== -1 || $route.path.indexOf('/resetPassword') !== -1|| $route.path==='/login' || $route.path==='/terms')? true : false">
          <img src="../../assets/headerLogo.png" class="sitelogo" alt="Site Logo">
        </a>
        <a href="/#" v-show="($route.path==='/' || $route.path==='/forgotPassword'|| $route.path==='/onBoard' || $route.path.indexOf('/onBoardMember') !== -1 || $route.path.indexOf('/resetPassword') !== -1|| $route.path==='/login' || $route.path==='/terms')? false : true">
          <img v-bind:src="clientLogoSrc" class="company-logo" alt="Site Logo">
        </a>

        <div class="navbar-burger burger" data-target="navMenu" @click="showOutNav = !showOutNav" :class="{ 'is-active': showOutNav }" v-show="($route.path==='/' || $route.path==='/forgotPassword'|| $route.path==='/requestDemo'|| $route.path.indexOf('/resetPassword') !== -1 || $route.path==='/onBoard' || $route.path.indexOf('/onBoardMember') !== -1)? true : false">
          <span></span>
          <span></span>
          <span></span>
        </div>

        <div class="navbar-burger burger" data-target="navMenu" @click="userMenuToggle()" :class="{ 'is-active': showNav }" v-show="($route.path==='/' || $route.path==='/forgotPassword'|| $route.path==='/requestDemo'|| $route.path.indexOf('/resetPassword') !== -1 || $route.path==='/login' || $route.path==='/onBoard' || $route.path.indexOf('/onBoardMember') !== -1 || $route.path==='/terms')? false : true">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      <div id="navMenu" class="navbar-menu outNavMenu" :class="{ 'is-active': showOutNav }" v-show="($route.path==='/' || $route.path==='/forgotPassword'|| $route.path==='/requestDemo'|| $route.path.indexOf('/resetPassword') !== -1 || $route.path==='/onBoard' || $route.path.indexOf('/onBoardMember') !== -1 || $route.path==='/terms')? true : false">
        <div class="navbar-end">
          <div class="navbar-item">
            <a href="#/login">
              Already have a free trial account?
            </a>
          </div>
        </div>
      </div>

      <div id="navMenu" class="navbar-menu" :class="{ 'is-active': showNav }" v-show="($route.path==='/' || $route.path==='/forgotPassword'|| $route.path==='/requestDemo'|| $route.path.indexOf('/resetPassword') !== -1 || $route.path==='/login' || $route.path==='/onBoard' || $route.path.indexOf('/onBoardMember') !== -1 || $route.path==='/terms')? false : true">

        <div class="navbar-end">
          <!-- User Account Menu -->
          <div class="navbar-item">
            <a class="upgradeLink" @click="openModal()">
              Upgrade to Pro
            </a>
          </div>
          <div class="navbar-item has-dropdown" @mouseover="addHover()" @mouseleave="removeHover()" :class="{ 'is-hoverable': hover }">
            <a class="navbar-link is-active">
              <img v-bind:src="userImageSrc" class="user-image" alt="User"/>&nbsp;
              {{currentUserName}}
            </a>
            <div class="navbar-dropdown user-menu">
              <div class="navbar-item text-center" v-if="$cookie.get('role')==='superAdmin'">
                <a href="#/admin">ChangeVU Admin</a>
              </div>
              <hr class="navbar-divider" v-if="$cookie.get('role')==='superAdmin'">
              <div class="navbar-item text-center" v-if="$cookie.get('role')==='superAdmin' || $cookie.get('role')==='companyAdmin'">
                <a href="#/teamInfo">Manage Team Member(s)</a>
              </div>
              <hr class="navbar-divider" v-if="$cookie.get('role')==='superAdmin' || $cookie.get('role')==='companyAdmin'">
              <div class="navbar-item text-center" v-if="$cookie.get('role')==='superAdmin' || $cookie.get('role')==='companyAdmin'">
                <a href="#/assessmentInfo">Manage Assessment</a>
              </div>
              <hr class="navbar-divider" v-if="$cookie.get('role')==='superAdmin' || $cookie.get('role')==='companyAdmin'">
              <div class="navbar-item text-center">
                <a href="#/accountSetting">Account Settings</a>
              </div>
              <hr class="navbar-divider">
              <div class="navbar-item text-center">
                <a v-on:click="logout()">Log Out</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>

    <div class="notification notificationModal" :class="{ isActive: modalOpen }">
      <button class="delete" @click="closeModal()"></button>
      <div class="content">
        <h2 class="is-title has-text-centered has-text-primary">
          <b>Want to upgrade to the Pro version?</b>
        </h2>
      </div>
      <hr />
      <div class="content">
        <ul>
          <li>
            Fully automated change risk and mitigation planning for teams
          </li>
          <li>
            No limit on number of assessments
          </li>
          <li>
            Create your unique implementation team success profile
          </li>
        </ul>
        <h5 class="is-title">
          Enable teams to reduce change risk rapidly and more successfully.
        </h5>
      </div>
      <div class="content">
        <form>
          <div class="field">
            <!-- <label class="label">Email address</label> -->
            <div class="control has-icon">
              <input class="input" v-model="upgrade.email" type="email" placeholder="Your Email">
              <span class="icon is-small">
                <i class="fa fa-envelope"></i>
              </span>
            </div>
          </div>
          <div class="field">
            <div class="additionalComment">
              <label class="label">Additional Comments</label>
              <div class="select" style="margin-bottom: 1rem;">
                <select v-model="upgrade.info">
                  <option value="" disabled>Information on</option>
                  <option value="infoRiskLicense">Change Risk teams license</option>
                  <option value="infoLicense">ChangeVU application license</option>
                  <option value="changePlatform">ChangeVU platform</option>
                </select>
              </div>
            </div>
            <div class="control" v-if="upgrade.info">
              <textarea class="textarea" v-model="upgrade.message" placeholder="Write something..."></textarea>
            </div>
          </div>
                  
          <div class="content">
            <div class="buttons has-text-centered">
              <button @click.prevent="submitUpgrade()" class="button is-primary">
                Send
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
// import { mapGetters, mapActions } from 'vuex'
import axios from 'axios'
import 'assets/scss/navbar.scss'
import { apiURL } from '../../globalConstants.js'
import router from '../../router'

export default {
  components: {
  },
  props: [ 'show', 'sidebar', 'expand' ],
  data () {
    return {
      modalOpen: false,
      apiUrl: apiURL,
      showOutNav: false,
      showNav: false,
      hover: false,
      user: '',
      upgrade: {
        name: '',
        email: '',
        info: '',
        message: ''
      },
      sidebarOpen: this.expand
    }
  },
  created () {
    let user = JSON.parse(window.localStorage.getItem('user'))
    if (user) {
      axios.get(apiURL + '/auth/local')
      .then(response => {
        if (response.data.profilePicture) {
          this.$store.commit('setUserImageSrc', apiURL + '/' + response.data.profilePicture)
        } else {
          this.$store.commit('setUserImageSrc', apiURL + '/uploads/' + 'extra-large.jpg')
        }
        if (response.data.logoPath) {
          this.$store.commit('setClientLogoSrc', apiURL + '/' + response.data.logoPath)
        } else {
          this.$store.commit('setClientLogoSrc', apiURL + '/uploads/' + 'changeVULogo.png')
        }
        this.$store.commit('setCurrentUserName', response.data.firstName + ' ' + response.data.lastName)
        this.$store.commit('setAssessmentCompleted', response.data.diagonacticStatus)
        this.upgrade.email = response.data.email
        this.upgrade.firstName = response.data.firstName
        this.upgrade.lastName = response.data.lastName
      })
      .catch(error => {
        this.$store.commit('setUserImageSrc', apiURL + '/uploads/' + 'extra-large.jpg')
        this.$store.commit('setClientLogoSrc', apiURL + '/uploads/' + 'changeVULogo.png')
        console.log(error)
      })
    }
  },
  computed: {
    userImageSrc () {
      return this.$store.state.userImageSrc
    },
    clientLogoSrc () {
      return this.$store.state.clientLogoSrc
    },
    currentUserName () {
      return this.$store.state.currentUserName
    }
  },
  methods: {
    toggleSidebar () {
      this.sidebarOpen = !this.sidebarOpen
      this.$emit('update:sidebar', this.sidebarOpen)
      this.isMobile = window.innerWidth < 1024
      if (this.isMobile) {
        if (this.showNav) {
          this.showNav = false
        }
      }
    },
    userMenuToggle () {
      this.showNav = !this.showNav
      this.isMobile = window.innerWidth < 1024
      if (this.isMobile) {
        if (this.sidebarOpen) {
          this.sidebarOpen = false
          this.$emit('update:sidebar', this.sidebarOpen)
        }
      }
    },
    logout () {
      window.localStorage.removeItem('Initiative')
      window.localStorage.removeItem('user')
      this.$cookie.delete('role')
      this.$cookie.delete('token')
      this.$auth.logout({
        makeRequest: false,
        success: function () {
          router.push({ path: '/login' })
        }
      })
    },
    openModal () {
      this.modalOpen = true
      this.showNav = false
    },
    closeModal () {
      this.modalOpen = false
      this.upgrade.info = ''
      this.upgrade.message = ''
    },
    addHover () {
      this.hover = true
    },
    removeHover () {
      this.hover = false
    },
    validateEmail (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    submitUpgrade () {
      if (!this.validateEmail(this.upgrade.email)) {
        this.$noty.error('Please enter valid email address.')
        this.upgrade.email = ''
      } else {
        axios.post(apiURL + '/api/v1/upgradeToPro', {name: this.upgrade.firstName + ' ' + this.upgrade.lastName, email: this.upgrade.email, topic: this.upgrade.info, details: this.upgrade.message})
        .then(response => {
          this.modalOpen = false
          this.upgrade.info = ''
          this.upgrade.message = ''
          this.$noty.success('Thanks for connecting with us. We will get back to you as soon as possible.')
        })
        .catch(error => {
          console.log(error)
        })
      }
    }
  },
  watch: {
    '$route': function (to, from) {
      this.showNav = false
      this.showOutNav = false
      this.hover = false
      this.isMobile = window.innerWidth < 1024
      if (this.isMobile) {
        this.sidebarOpen = false
        this.$emit('update:sidebar', this.sidebarOpen)
      }
    }
  },
  mounted () {
    this.$root.$on('update:sidebar', (newVal) => {
      this.sidebarOpen = newVal
    })
  }
}
</script>

<style lang="scss">
@import '~bulma/sass/utilities/variables';

.sitelogo {
  width: 200px;
  margin: 5px 0px;
}

.company-logo {
  width: 200px;
  height: 60px;
}

.hovertable {
  thead {
    background: lightgrey !important;
    text-align: center;
    font-size: 1rem !important;
    tr:hover {
      background: lightgrey !important;
    }
    th {
      border: 3px solid #fff !important;
      text-align: center !important;

      &:first-child {
        border-radius: 15px 0 0 0;
      }
      &:last-child {
        border-radius: 0 15px 0 0;
      }
    }
  }

  tbody {
    td {
      border: 3px solid #fff !important;
      vertical-align: middle !important;
      .tableData {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }
  }

  tfoot {
    background: lightgrey !important;
    font-size: 14px;
    font-weight: bold;
    tr {
      &:hover {
        background: lightgrey !important;
      }
      &:last-child td:first-child {
        border-radius: 0 0 0 15px;
      }
      &:last-child td:last-child {
        border-radius: 0 0 15px 0;
      }
    }
    td {
      border: 3px solid #fff !important;
      .tableData {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }
    .dataHolder {
      min-width: 20px !important;
      text-align: center !important;
    }
  }
}

.colorGreenOpacity {
  fill: hsl(120, 100%, 25%);
  opacity: 0.5;
}
.colorYellowOpacity {
  fill: hsl(60, 100%, 50%);
  opacity: 0.5;
}
.colorRedOpacity {
  fill: hsl(3, 100%, 50%);
  opacity: 0.5;
}
.colorSvgWhite {
  fill: #fff;
}
.colorSvgBlack {
  fill: #000;
}

.colorDefault {
  background-color: #f9f9f9;
}

.boxSelected {
  box-shadow: 0px 0px 1px 2px #66f;
}

.initiativeDetails {
  text-align: center;
}

.initiativeDetailsHide {
  display: none;
}

.notificationModal {
  display: none;
  background: #fff !important;
  padding: 0rem !important;
  -ms-overflow-style: none;
  scrollbar-width: none; 
  overflow: -moz-scrollbars-none;
  &::-webkit-scrollbar {
    display: none;
  }

  .additionalComment {
    display: flex;
    justify-content: space-between;
    align-items: center;
    @media screen and (max-width: 767px) {
      flex-direction: column;
      align-items: flex-start;
    }
  }
}

.isActive {
  display: block;
}
.dateInput {
  .vdatetime-input {
    padding-left: 2.25em;
    -moz-appearance: none;
    -webkit-appearance: none;
    -ms-flex-align: center;
    align-items: center;
    border: 1px solid transparent;
    border-radius: 3px;
    box-shadow: none;
    display: -ms-inline-flexbox;
    display: inline-flex;
    font-size: 1rem;
    height: 2.25em;
    -ms-flex-pack: start;
    justify-content: flex-start;
    line-height: 1.5;
    padding-bottom: calc(0.375em - 1px);
    padding-right: calc(0.625em - 1px);
    padding-top: calc(0.375em - 1px);
    position: relative;
    vertical-align: top;
    background-color: #fff;
    border-color: #dbdbdb;
    color: #363636;
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
    max-width: 100%;
    width: 100%;
  }
}
</style>


<style>
/*@media screen and (max-width: 1150px) and (min-width: 768px) {
  .dashboard-menu {
    width: 700px!important;
  }
}
@media screen and (max-width: 1350px) and (min-width: 1150px){
  .dashboard-menu {
    width: 800px!important;
  }
}*/
</style>



// WEBPACK FOOTER //
// Navbar.vue?50bf6f86